export const getActionLabel = (str: string) => {
  switch (str) {
    case 'YES':
      return 'Да';
    case 'NO':
      return 'Нет';
    case 'CANCEL':
      return 'Отмена';
    default:
      return str;
  }
};
